export default "__VITE_ASSET__DLDAUqW0__"